
import { ref } from "vue";
import { Options, mixins } from "vue-class-component";
import StoreReports from "../../service/StoreReports";
import UtilityOptions from "../../mixins/UtilityOptions";
import ProfilerService from "../../service/ProfilerService.js";
import UserService from "../../service/UserService.js";
import AutoComplete from "primevue/autocomplete";

interface salesReportList {
  receiptDate:string,
  receiptNo:string,
  cashierName:string,
  discount:string,
  totalBill:string,
  totalGoodsValue:string,
  paymentMethod:string,
  payLaterBalance:string,
  billNo:string,
  supplierName: string
}

@Options({
  title: 'Purchase Returns Report',
  components: {AutoComplete},
  watch: {
    lists: {
      handler(newLists) {
        this.totalSubTotal = newLists.reduce(
          (acc, item) => acc + (parseFloat(item.totalBill) || 0),
          0
        );
        this.totalDiscounts = newLists.reduce(
          (acc, item) => acc + (parseFloat(item.discount) || 0),
          0
        );
        this.totalPayLater = newLists.reduce(
          (acc, item) => acc + (parseFloat(item.payLaterBalance) || 0),
          0
        );
        this.goodsValueTotal = newLists.reduce(
          (acc, item) => acc + (parseFloat(item.totalGoodsValue) || 0),
          0
        );
      },
      immediate: true,
    },
  },
})

export default class PurchaseReturnReport extends mixins(UtilityOptions) {
  private totalSubTotal = 0;
  private goodsValueTotal = 0;
  private totalDiscounts = 0;
  private totalPayLater = 0;
  private dt = ref();
  private lists: salesReportList[] = [];
  private profilerList = [];
  private userList = [];
  private reportService;
  private profilerService;
  private userService;
  private resultTitle = "";
  private productDialog = false;
  private loading = false;
  private home = { icon: "pi pi-home", to: "/" };
  private items = [
    { label: "Reports", to: "index" },
    { label: "Purchase Returns Report", to: "purchase-return-report" },
  ];
  private checkPagination = true;
  private limit = 0;
  private totalRecords = 0;
  private goToFirstLink = 0;

  private searchFilters = {
    filterType:"None",
    date1: "",
    date2: "",
    cashierID: 0,
    branchID: 0,
    paymentMethodID: 0,
  };

  // private taxNames = [
  //   {
  //     taxName: "",
  //     show: false,
  //     optionalReq: "",
  //     taxValue: 0,
  //     accountHead: "",
  //     accountID: 0,
  //   },
  //   {
  //     taxName: "",
  //     show: false,
  //     optionalReq: "",
  //     taxValue: 0,
  //     accountHead: "",
  //     accountID: 0,
  //   },
  //   {
  //     taxName: "",
  //     show: false,
  //     optionalReq: "",
  //     taxValue: 0,
  //     accountHead: "",
  //     accountID: 0,
  //   },
  // ];

  // private reportTypes = [
  //   {
  //     name: 'Sales',
  //   },
  //   {
  //     name: 'Refund',
  //   },
  // ];

  // private brands:any = [];
  // private sectors:any = [];
  // private categories:any = [];
  // private productTypes:any = [];

  private filterBranch;
  private paymentMethods;
  private cashiers;
  private filterDates = [];
  private dialogTitle;
  private submitted = false;

  data() {
    return {
      lists: [], // Your data
      totalSubTotal: 0, // Total for subTotal column
    }
  }
  
  //CALLING WHEN PAGINATION BUTTON CLICKS
  onPage(event) {
      this.loadList(event.first);
  }

  //CALLING WHENEVER COMPONENT LOADS
  created() {
    this.reportService = new StoreReports();
    this.profilerService = new ProfilerService();
    this.userService = new UserService();
  }
  
   //CALLNING AFTER CONSTRUCTOR GET CALLED
  mounted() {
    this.loadFilers();
    this.loadList(0);
  }

  //OPEN DIALOG TO ADD NEW ITEM
  openDialog() {       
    this.submitted = false;
    this.dialogTitle = "Filter Report";
    this.productDialog = true;
  }  
  //CLOSE DIALOG
  closeDialog() {
      this.productDialog = false;
  }

  loadFilers()
  {
    this.reportService.getFilterList().then((res) => {
      this.filterBranch  = res.branches;
      this.filterDates   = res.datesList;
      this.paymentMethods = res.payment_methods;
      this.cashiers = res.cashiers;
      this.cashiers.push({id:0, name:'All'}); 
      this.paymentMethods.push({id:0, name:'All'}); 
      this.filterBranch.push({id:0, name:'All'}); 

    });
  }
 
  // USED TO GET SEARCHED ASSOCIATE
  loadList(page) {
    this.loading = true;
    this.reportService.purchaseReturnsReport(this.searchFilters, page).then((res) => {
        const data = this.camelizeKeys(res);
        this.resultTitle = data.resultTitle;
        this.lists = data.record;
        this.loading = false;
        this.limit = data.limit;
        this.totalRecords = data.totalRecords;
        this.goToFirstLink = page;
        this.closeDialog();
      });
    this.productDialog = false;
  }

  // searchProfiler(event) {
  //   setTimeout(() => {
  //     this.profilerService.searchProfiler(event.query.trim()).then((data) => {
  //       this.profilerList = data.records;
  //     });
  //   }, 200);
  // }
  
  // searchUser(event) {
  //   setTimeout(() => {
  //     this.userService.searchUser(event.query.trim()).then((data) => {
  //       this.userList = data.records;
  //     });
  //   }, 200);
  // }

  saveProfile(event) {
    const profileInfo = event.value;
    // this.searchFilters.customerName = profileInfo.account_title;
    // this.searchFilters.customerID = profileInfo.id;
  }
  
  // saveUser(event) {
  //   const userInfo = event.value;
  //   // this.searchFilters.UserName = userInfo.name;
  //   // this.searchFilters.userID = userInfo.id;
  // }

  get currency() {
    return this.store.getters.getCurrency;
  }

  get rList() {
      const l: salesReportList[] = [];

      this.lists.forEach((e) => {
          l.push(e);
      });

      return l;
  }
}
